import { render, staticRenderFns } from "./seatCol.vue?vue&type=template&id=218388b4&scoped=true&"
import script from "./seatCol.vue?vue&type=script&lang=js&"
export * from "./seatCol.vue?vue&type=script&lang=js&"
import style0 from "./seatCol.vue?vue&type=style&index=0&id=218388b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218388b4",
  null
  
)

export default component.exports